import { InjectionToken, Provider } from '@angular/core';
import getEnvironmentSettings from '../../commons/configs/env-conf-loader';
const ENVIRONMENT_SETTINGS = getEnvironmentSettings();

export const LOCATIONS_API_URL = new InjectionToken<string>("LOCATIONS_API_URL");
export const LocationsApiUrlProvider: Provider = {
    provide: LOCATIONS_API_URL,
    useValue: ENVIRONMENT_SETTINGS.cdLocationsApiUrl
}